import { BoardPurchaseFloorInterface } from '../interfaces/board-purchase-floor.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';

import { ApiProperty } from '@nestjs/swagger';

import { IsNumber, IsUUID } from 'class-validator';

import { Exclude, Expose, Type } from 'class-transformer';
import { BoardPurchaseInterface } from '../../board-purchase/interfaces/board-purchase.interface';
import { BoardTypeInterface } from '../../board-type/interfaces/board-type.interface';

@Exclude()
export class BoardPurchaseFloorDto
  extends CommonEntityDto
  implements BoardPurchaseFloorInterface
{
  @ApiProperty({
    title: 'Floor Number',
    description: 'The Floor Number',
  })
  @IsNumber()
  @Type(() => Number)
  @Expose()
  floor!: number;

  @ApiProperty({
    title: 'Quantity Number',
    description: 'The Floor Number',
  })
  @IsNumber()
  @Type(() => Number)
  @Expose()
  quantity!: number;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Purchase Id',
    description: 'Board Purchase Id',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;

  @ApiProperty({
    title: 'Board Purchase',
    description: 'Board Purchase',
  })
  @Expose()
  boardPurchase?: BoardPurchaseInterface | undefined;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Type Id',
    description: 'Board Type Id',
  })
  @IsUUID()
  @Expose()
  boardTypeId!: string;

  @ApiProperty({
    title: 'Board Type',
    description: 'Board Type',
  })
  @Expose()
  boardType!: BoardTypeInterface;
}
